import React, { useEffect, useContext } from "react";
import { LoadingContext } from './../../../src/Pages/Utility/spinner/LoadingContext';
import UsePanel from "./UserPanel";
import CategoryChartCard from "./ProjectCategoryChartCard";
import OverView from "./OverView";
import LatestValuations from "./LatestValuations";
import ProjectStatus from "./ProjectStatus";
import Notifications from "./Notifications";
import { Container, Row } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const Dashboard = () => {
  const { setIsLoading } = useContext(LoadingContext);

  useEffect(() => {
    document.title = "Dashboard | Valitan";

    // Optional: Set initial loading state for dashboard
    setIsLoading(true);
    // Simulate initial data fetching for child components
    const timer = setTimeout(() => {
      setIsLoading(false); // Turn off spinner after child components load
    }, 1000); // Adjust delay based on typical child component fetch time

    return () => clearTimeout(timer);
  }, [setIsLoading]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Dashboard" />
          {/* User Panel Charts */}
          <UsePanel />

          <Row>
            {/* Overview Chart */}
            <OverView />
            {/* Social Source Chart */}
            <CategoryChartCard />
          </Row>

          {/* Latest Valuations Table */}
          <LatestValuations />
          <Row>
            {/* Order Stats */}
            <ProjectStatus />
            {/* Notifications */}
            <Notifications />

            <Notifications />
          </Row>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;